import { post } from "./api.js";

const PREFIX = "Revista Española de Ciencias Farmacéuticas - ";

export let sendEmail = async (to, subject, body, attached = []) => {
  await post(
    "EnviarCorreo",
    {
      email: to,
      asunto: PREFIX + subject,
      body,
      adjuntos: attached,
    },
    null
  );
};
